export type TPlan = "trial" | "starter" | "pro" | "team";
export const PLAN_HIERARCHY: TPlan[] = ["trial", "starter", "pro", "team"];

export type PresetFeatures = {
  [key: string]: unknown;
};

export type PlanPresets = {
  starter?: PresetFeatures;
  pro?: PresetFeatures;
  team?: PresetFeatures;
};

export type FeatureResult = "enabled" | "contact" | unknown;
